import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Button, Card, Col, Form, Row, Select, Space, Spin } from 'antd';

import { handlePostApi } from '@/api/crud';
import {
  branchAccessEndpoints,
  companyAccessEndpoints,
  customerApiEndpoints,
  roleApiEndpoints,
} from '@/api/endpoints';
import { useFetch } from '@/hooks';

import { optionSearchFunction } from '@/utils/common';
import { rules } from '@/utils/validation/FormValidation';

const RoleMapping = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm(); //Form hooks for managing hooks state
  const [selectedCompany, setSelectedCompany] = useState(null); // To store selected company ID

  const [userData, setUserData] = useState([]); // To store fetched users
  const navigate = useNavigate();
  const { data: companyData } = useFetch(branchAccessEndpoints.retrieveList);

  const handleCompanyChange = (value) => {
    setUserData([]);
    setSelectedCompany(value);
    form.setFieldsValue({
      roleId: [],
      userList: [],
    });
  };

  const fetchUsers = async (companyId) => {
    setLoading(true);
    try {
      const { data } =
        await customerApiEndpoints.companyWiseCustomer(companyId);
      setUserData(data.data);
    } finally {
      setLoading(false);
    }
  };

  // useEffect to trigger fetching roles and users when a company is selected
  useEffect(() => {
    if (selectedCompany) {
      fetchUsers(selectedCompany);
    }
  }, [selectedCompany]);

  return (
    <>
      <section className="">
        <Card>
          <Form
            className="username"
            form={form}
            size="middle"
            layout="vertical"
            onFinish={(value) =>
              handlePostApi(roleApiEndpoints.mapping, value, setLoading, form)
            }
          >
            <Spin spinning={loading}>
              <div>
                <Row gutter={[16, 16]}>
                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Select Branch"
                      name="branchId"
                      validateTrigger="onChange"
                      rules={rules.required}
                    >
                      <Select
                        showSearch
                        placeholder="Select Branch"
                        filterOption={optionSearchFunction}
                        options={companyData?.map((item) => {
                          return {
                            value: item.referenceId,
                            label: item?.name,
                          };
                        })}
                        onChange={handleCompanyChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Users"
                      name="userList"
                      rules={rules.required}
                      validateTrigger="onChange"
                    >
                      <Select
                        showSearch
                        placeholder="Users"
                        mode="multiple"
                        allowClear
                        filterOption={optionSearchFunction}
                        options={userData.users?.map((item) => {
                          return {
                            value: item.referenceId,
                            label: item.name,
                          };
                        })}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Role"
                      name="roleId"
                      rules={rules.required}
                      hasFeedback
                      validateTrigger="onChange"
                    >
                      <Select
                        placeholder="Role"
                        showSearch
                        filterOption={optionSearchFunction}
                        options={
                          userData.roles?.map((item) => {
                            return {
                              value: item.referenceId,
                              label: item.name,
                            };
                          }) || []
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div style={{ textAlign: 'right' }}>
                <Space size="large">
                  <Button type="primary" htmlType="submit" disabled={loading}>
                    ASSIGN
                  </Button>

                  <Button type="primary" danger onClick={() => navigate(-1)}>
                    CANCEL
                  </Button>
                </Space>
              </div>
            </Spin>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default RoleMapping;
